<template>
  <b-container fluid class="ps-0">
    <b-row>
      <b-col lg="3" xl="2" xxl="2" md="3" sm="2" class="staticleftsidebar">
        <LeftBar
          pagename="Grndetails"
          masterheading="Manufacture Master"
          v-model="Id"
          :storestatus="true"
          :listed="sidebardata"
          :paramValues="ParamValues"
        >
        </LeftBar>
        <a class="back-btn" @click="$router.back">
          <img
            alt="Vue logo"
            class="back"
            src="../../../../../../assets/Img/icons/backtoright.svg"
            width="125"
            height="125"
          />
        </a>
      </b-col>
      <b-col lg="9" xl="10" xxl="10" md="9" sm="10">
        <b-container>
          <b-row>
            <b-col class="my-5">
              <p class="light-txt">SUP9856</p>
              <Headerlayout headertext="Emergency Supplies"></Headerlayout>
            </b-col>
          </b-row>
          <!-- {{ Id }} -->
          <b-row>
            <b-col>
              <Tableview
                :value="items"
                :paginator="true"
                class="p-datatable-gridlines"
                :rows="10"
                dataKey="id"
                :rowHover="true"
                filterDisplay="menu"
                :loading="loading1"
                responsiveLayout="scroll"
                :columns="headers"
                :globalFilterFields="globalFilterFields"
                :filters="filters"
              >
                <template v-slot:Add> </template>
                <template v-slot:action="{ data }">
                  <span>
                    <EditIcon />
                    <DeleteIcon />
                  </span>
                </template>
              </Tableview>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script lang="ts">
import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import { defineComponent, ref, computed, onMounted, watch } from "vue";
import LeftBar from "../../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";

// import Rightsidebar from '../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsSidebar.vue'
import Log from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import { useRoute, useRouter } from "vue-router";
import POTableview from "../../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import RequestTable from "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/RequestTable.vue";
import PITable from "../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import IssueTable from "../../../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/ItemIssueTable.vue";
import PurchaseIndentTableVue from "../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import QuotesTableview from "../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/QuotesTableview.vue";
import storetab from "../../../../../../modules/Inventory/pages/Masters/Stores/StoreMaster/StoreTab/mainstore.vue";
import ItemStoreMappingCreation from "../../../../../../modules/Inventory/pages/Masters/Items/StoreMappingItemCategory/ItemStoreMappingTblview.vue";
import service from "../../../../../../modules/Inventory/Service/ManufacturerService";
import WithoutStockService from "../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import ManufacturerMasterTableview from "../../../../../../modules/Inventory/pages/Masters/Manufacturer/ManufacturerMaster/ManufacturerMasterTableview.vue";
import ManufacturerDetailsVue from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerDetails.vue";
import ManufacturerItemMappingTable from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerItemMappingTable.vue";
import ManufacturerSupplierMappingTable from "../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerSupplierMappingTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import commonService from "../../../../Service/StockInService";

export default defineComponent({
  components: {
    ItemStoreMappingCreation,
    QuotesTableview,
    POTableview,
    LeftBar,
    Details,
    MemberDetails,
    // Rightsidebar,
    Log,
    Headerlayout,
    PurchaseIndentTableVue,
    RequestTable,
    PITable,
    IssueTable,

    storetab,
    ManufacturerMasterTableview,
    ManufacturerSupplierMappingTable,
    ManufacturerDetailsVue,
    ManufacturerItemMappingTable,
    Tableview,
  },
  props: {
    showDetailsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    showItemsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    // items: {
    //     type: Array,
    //     default: () => [],
    // },

    propsParams: {
      type: Object,
    },
  },
  setup() {
    onMounted(() => {
      IsShow(), IsShowByStockOutId();
    });
    let items = ref([]);
    let loading1 = ref(false);

    let sidebardata = ref([]);
    let Id = ref([]);
    const { t } = useI18n();

    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);

    const paramValue = computed(() => {
      return route.query.param as string;
    });

    //Table List
    const headers = [
      {
        header: t("storetabdetails.grndetailstable.Item"),
        field: "ItemCode",
      },
      // {
      //   header: "HSN #",
      //   field: "HSNCode",
      // },
      // {
      //     header: "Category",
      //     field: "ItemCategory1",
      // },
      {
        header: t("storetabdetails.grndetailstable.Itemname"),
        field: "Itemname1",
      },
      {
        header: t("storetabdetails.grndetailstable.UOM"),
        field: "ItemQuantity",
      },
      {
        header: t("storetabdetails.grndetailstable.Quantity"),
        field: "ItemQuantity",
      },
      {
        header: t("storetabdetails.grndetailstable.PurchasingUnit"),
        field: "PurchaseUnit",
      },

      {
        header: t("storetabdetails.grndetailstable.Unitrate"),
        field: "UnitRate",
      },
      {
        header: t("storetabdetails.grndetailstable.Tax"),
        field: "taxamount",
      },
      {
        header: t("storetabdetails.grndetailstable.Discount%"),
        field: "Discount",
      },
      {
        header: t("storetabdetails.grndetailstable.DiscountAmount"),
        field: "DiscountAmount",
      },
      {
        header: t("storetabdetails.grndetailstable.TotalValue"),
        field: "Totalvalue",
      },
      {
        header: t("storetabdetails.grndetailstable.SalesUnit"),
        field: "SalesUnitName",
      },
      {
        header: t("storetabdetails.grndetailstable.SalesTax"),
        field: "Salestaxamount",
      },
      {
        header: t("storetabdetails.grndetailstable.Margin"),
        field: "ItemQuantity",
      },
      {
        header: t("storetabdetails.grndetailstable.SalePrice"),
        field: "SalesPrice",
      },
      {
        header: t("storetabdetails.grndetailstable.MRP"),
        field: "MRP",
      },

      // {
      //   header: "Total Value",
      //   field: "unit rate",
      // },
      {
        field: "action",
        header: "Action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      RefNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      ToStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };
    async function IsShow() {
      try {
        let response = await commonService.GetStockInTMTableList(
          "7,8",
          ParamValues.value.StoreId,
          HospitalId
        );
        sidebardata.value = response["result"];
        const oldKey1 = "SupplierName";
        const newKey1 = "Name";
        const oldKey2 = "DocNo";
        const newKey2 = "Code";

        sidebardata.value = response["result"].map((item) => {
          const newItem = {
            ...item,
            [newKey1]: item[oldKey1],
            [newKey2]: item[oldKey2],
          };
          delete newItem[oldKey1];
          delete newItem[oldKey2];
          return newItem;
        });

        console.log(sidebardata.value);
      } catch (error) {
        console.log(error);
      }
    }
    const route = useRoute();

    debugger;
    const ParamValues = ref({
      Id: 0,
      StoreId: 0,
    });
    let manufacturerId = route.query.id;
    console.log(manufacturerId);
    ParamValues.value.Id = Number(route.query.id);
    ParamValues.value.StoreId = Number(route.query.storeid);
    console.log(ParamValues.value.Id);
    watch(
      () => route.query.id,
      (newVal: any) => {
        debugger;

        ParamValues.value.Id = Number(newVal);
        ParamValues.value.StoreId = Number(newVal);

        console.log(ParamValues.value.Id);

        IsShowByStockOutId();
      }
    );
    async function IsShowByStockOutId() {
      debugger;
      console.log(ParamValues.value.Id);
      const result = await commonService.getlistById(ParamValues.value.Id);
      console.log(result["result"]);
      items.value = result["result"];
      console.log(items.value);
    }
    return {
      sidebardata,
      paramValue,
      IsShow,
      Id,
      loading1,
      headers,
      globalFilterFields,
      filters,
      items,
      ParamValues,
    };
  },
});
</script>

<style lang="scss">
.p-tabview-header span {
  white-space: nowrap;
}

.tabview-custom {
  width: 99%;
}

.staticleftsidebar {
  position: sticky !important;
  top: 0;
}
</style>
